import { Link } from 'react-router-dom';
import Breadcrumb from '@/components/feature/Breadcrumb';
import TeamBadge from '@/components/base/TeamBadge';
import { useSEO } from '@/hooks/useSEO';
import { allLeagues, getTeamsByLeague } from '@/utils/data';

export default function TeamsPage() {
  useSEO({
    title: '球队资料大全 - 篮球比分',
    description: '汇总 NBA、CBA、欧洲篮球联赛等国内外主要联赛球队的基本资料、赛季排名与近期战绩。',
    keywords: '篮球球队,球队资料,NBA球队,CBA球队,篮球排名',
  });

  return (
    <div className="px-4 md:px-6 py-6 animate-fade-up">
      <Breadcrumb items={[{ label: '首页', to: '/' }, { label: '球队' }]} />
      <header className="mt-4 mb-6">
        <h1 className="font-heading font-extrabold text-2xl md:text-3xl text-foreground-950">球队资料</h1>
        <p className="mt-2 text-sm md:text-[15px] text-foreground-600 max-w-3xl">
          浏览各联赛球队的基本资料与赛季表现，点击任意球队可查看完整阵容与近期战绩。
        </p>
      </header>

      <div className="space-y-8">
        {allLeagues.map((league) => {
          const teams = getTeamsByLeague(league.id);
          if (teams.length === 0) return null;
          return (
            <section key={league.id}>
              <div className="flex items-center justify-between mb-3">
                <h2 className="flex items-center gap-2 font-heading font-bold text-lg text-foreground-900">
                  <span className="w-1.5 h-5 rounded-full bg-primary-500"></span>
                  {league.name}
                  <span className="text-xs font-normal text-foreground-500">（{league.shortName}）</span>
                </h2>
                <Link to={`/category/${league.id}`} className="text-xs md:text-sm text-primary-600 hover:text-primary-700 cursor-pointer whitespace-nowrap flex items-center gap-1">
                  赛程
                  <i className="ri-arrow-right-s-line"></i>
                </Link>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3">
                {teams.map((t) => (
                  <Link
                    key={t.id}
                    to={`/team/${t.id}`}
                    className="group flex items-center gap-3 p-4 rounded-lg bg-background-50 border border-background-200/80 hover:border-primary-300 hover:bg-primary-50/40 transition-colors cursor-pointer"
                  >
                    <TeamBadge team={t} size="md" />
                    <div className="min-w-0 flex-1">
                      <p className="text-sm font-semibold text-foreground-900 truncate group-hover:text-primary-600 transition-colors">{t.name}</p>
                      <p className="text-xs text-foreground-500 truncate">{t.city} · {t.win} 胜 {t.loss} 负</p>
                    </div>
                    <span className="shrink-0 text-xs font-heading font-bold text-accent-700">#{t.rank}</span>
                  </Link>
                ))}
              </div>
            </section>
          );
        })}
      </div>
    </div>
  );
}